import styled from "styled-components";

export const SPricingCardsContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 28px;
  flex: 1;
`;
